import React from "react";
import EntriesDropdown from "./EntriesDropdown";

/**
 * Table header toolbar:
 * Left  — Show entries
 * Right — Search (+ optional refresh / extra actions)
 */
const TableToolbar = ({
  entriesPerPage,
  onEntriesChange,
  entriesOptions,
  searchValue = "",
  onSearchChange,
  searchPlaceholder = "Search...",
  onRefresh,
  left = null,
  children = null,
}) => {
  const showEntries =
    typeof onEntriesChange === "function" && entriesPerPage != null;

  return (
    <div className="xc-list-toolbar xc-table-toolbar">
      <div className="xc-list-toolbar__left">
        {showEntries ? (
          <EntriesDropdown
            entriesPerPage={entriesPerPage}
            onEntriesChange={onEntriesChange}
            options={entriesOptions}
          />
        ) : null}
        {left}
      </div>
      <div className="xc-list-toolbar__right">
        {onSearchChange ? (
          <div className="xc-table-search">
            <i
              className="ri-search-line xc-table-search__icon"
              aria-hidden="true"
            />
            <input
              type="search"
              className="form-control xc-table-search__input"
              placeholder={searchPlaceholder}
              value={searchValue}
              onChange={onSearchChange}
              autoComplete="off"
            />
          </div>
        ) : null}

        {children}
      </div>
    </div>
  );
};

export default TableToolbar;
